import type { ScopeView } from "@nabla/api";
import { formatPeriod, zoneSuffix } from "../../design/format/dates.ts";
import { capitalized } from "../../design/format/text.ts";
import { levelCopy } from "../../features/campaign/copy.ts";
import { storeInsightsCopy as t } from "./copy.ts";
import { sourceNamed, type Words } from "../../words/session.ts";

export const overview = (view: ScopeView, words: Words) => {
  const section = view.modules?.["store-insights"];
  if (section === undefined) return undefined;
  const { sessions, carts, checkouts, completed, cartRate, checkoutRate } = section;
  const store = sourceNamed(sessions.source, words);
  const { from, to, timezone } = sessions.window;
  const origin = levelCopy.origem.janela(capitalized(store.nome), formatPeriod(from, to, words.today), zoneSuffix(timezone));
  return { title: t.titulo(store.da), figures: [sessions, carts, checkouts, completed, cartRate, checkoutRate], origin, folded: true };
};
